'use strict';
define(['./settings-navigation'], function(getSettingsNavigation) {
    function SettingsController($scope, $state, LanguageService, currentUser, $filter, $mdMedia) {
        var vm = $scope;
        vm.currentUser = currentUser;
        vm.$mdMedia = $mdMedia;

        vm.userIsEnabledToSeePartnerArea = userIsEnabledToSeePartnerArea();

        function userIsEnabledToSeePartnerArea() {
            return LanguageService.getLocale() === 'it_IT';
        }

        vm.menuConfig = {
            singleOpening: false,
            linkFirstLevelMenuToTheFirstSubmenu: true,
            saveStateOnRefresh: true
        };

        vm.mobileMenuItems = [];

        vm.menuItems = getSettingsNavigation();

        buildMobileMenu(vm.menuItems);

        function buildMobileMenu(menuItems) {
            for (var i = 0; i<menuItems.length; i+=1) {
                if (menuItems[i].link) {
                    vm.mobileMenuItems.push(menuItems[i]);
                }
                if (menuItems[i].submenu) {

                    for (var j = 0; j<menuItems[i].submenu.length; j+=1) {
                        if (menuItems[i].submenu[j].link) {
                            vm.mobileMenuItems.push(menuItems[i].submenu[j]);
                        }

                        if (menuItems[i].submenu[j].submenu) {
                            for (var k = 0; k<menuItems[i].submenu[j].submenu.length; k+=1) {
                                if (menuItems[i].submenu[j].submenu[k].link) {
                                    vm.mobileMenuItems.push(menuItems[i].submenu[j].submenu[k]);
                                }
                            }
                        }
                    }
                }

            }

            vm.mobileMenuItems = $filter('orderBy')(vm.mobileMenuItems, 'mobileTabOrder', false);
        }

        vm.goTo = function(item, ev) {

            vm.current = item;
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }


            if (item.link && item.link.type == 'internal') {
                $state.go(item.link.url);
            }

            if (item.link && item.link.type == 'external') {
                $window.open(item.link.url, '_blank');
            }

        }

    }
    SettingsController.$inject=['$scope', '$state', 'LanguageService', 'currentUser', '$filter', '$mdMedia'];
    return SettingsController;
});
